import React, { useState, useEffect } from 'react'
import moment from 'moment';
import { getRunningLoansCountsAPi, getRunningLoansDetailsAPi, getBisbursedLoansDetailsAPi, getStatsByNPAAgeingDaysAPi, getLoanRecoveredDetailsAPi, GetPortfolioOverviewReportByDate, GetPortfolioOverviewcurrentOutstandingReportByDate, getProdcutList } from '../../AdminActionCreator.component';
import Loader from '../../../../presentationals/Loader/Loader.component'
import Nodataimage from '../../../../../images/nodata.png'
import { APIS } from '../../../../../utils/api-factory';
const activeTabcss = {
    background: "#4D84C7",
    color: "#fff",
    cursor: 'pointer'

}



const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}


const DefaultDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'startDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'endDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }

}

export default function Main({ admin }) {
    const itemsPerPage = 10;
    const [loader, setLoader] = useState(false)
    const [payload, setPayload] = useState({
        sDate: DefaultDate("startDate"), eDate: DefaultDate("endDate"),
        nbfcId: "",
        product: ""
    })
    const [showclearbtn, setShowclearBtn] = useState(false)
    const [tabType, setTabType] = useState('runningLoans')
    const [TableData, setTableData] = useState([])
    const [pageValues, setPageValues] = useState({ count: 1, total: 1, buttonDisable: false })
    const [tabData, setTabData] = useState({})
    const [currentOustanding, setcurrentOutstanding] = useState('')
    const [productList, setproductList] = useState([])
    const [nbfcData, setnbfcData] = useState([])

    const getNbfcList = () => {
        fetch(APIS.GET_LIST_OF_NBFC)
            .then(res => res.json())
            .then(res => {
                setnbfcData(res)

            })
    }

    const GetProduct = () => {
        getProdcutList(callback => {
            setproductList(callback?.data)
        })
    }

    const handleChange = (e, name) => {
        setPayload((prev) => ({
            ...prev,
            [name]: e.target.value
        }))
        setShowclearBtn(true)
    }

    const handleActionbtn = (actionType) => {
        if (actionType === "apply") {
            setShowclearBtn(true)
            getRunningLoansCountsFunction(payload)
            getStatsByNPAAgeingDaysFunction(payload, 1, true)
            ApicallActiveSection(tabType, 1)

        } else if (actionType === "clear") {
            const updatePayload = {
                sDate: DefaultDate("startDate"), eDate: DefaultDate("endDate"), nbfcId: ""
            }
            setPayload(updatePayload)
            getRunningLoansCountsFunction(updatePayload)
            getStatsByNPAAgeingDaysFunction(payload, 1, true)
            ApicallActiveSection(tabType, 1)
            setShowclearBtn(false)
        }
    }

    const handleShowTab = (type) => {
        setTabType(type)
        setTableData([])
        ApicallActiveSection(type, 1)
        setPageValues({
            count: 1,
            total: type === "runningLoans" ? tabData?.totalRunningLoan : type === "disbursmentLoans" ? tabData?.totalDisbursedLoan : type === "loanRecovered" ? tabData?.totalRecoveredCount : 1,
            buttonDisable: false
        })
    }

    const paginationHandler = (type, showType) => {
        const data = showType === "runningLoans" ? tabData?.totalRunningLoan : showType === "disbursmentLoans" ? tabData?.totalDisbursedLoan : showType === "loanRecovered" ? tabData?.totalRecoveredCount : 0
        if (type == 'left') {
            if (pageValues.count > 1) {

                setPageValues(prevState => {
                    const newState = {
                        ...prevState,
                        count: prevState.count - 1,
                        total: data,
                        buttonDisable: false
                    };
                    ApicallActiveSection(showType, (pageValues?.count - 1));
                    return newState;
                });

            } else {
                setPageValues(prevState => {
                    const newState = {
                        ...prevState,
                        count: prevState.count,
                        total: data,
                        buttonDisable: false
                    };

                    return newState;
                });
            }
        }
        if (type == 'right') {
            if (data >= 10 && pageValues?.count < Math.ceil(data / itemsPerPage)) {
                setPageValues(prevState => {
                    const newState = {
                        ...prevState,
                        count: prevState.count + 1,
                        total: data,
                        buttonDisable: false
                    };
                    ApicallActiveSection(showType, (pageValues?.count + 1));
                    return newState;
                });
            } else {

                setPageValues(prevState => {
                    const newState = {
                        ...prevState,
                        count: prevState.count,
                        total: data,
                        buttonDisable: true
                    };

                    return newState;
                });
            }
        }
    }

    const ApicallActiveSection = (type, count) => {
        if (type == "runningLoans") {
            getRunningLoansDetailsFunction(payload, count)
        } else if (type == "disbursmentLoans") {
            getBisbursedLoansDetailsFunction(payload, count)
        } else if (type == "npaAgingDays") {
            getStatsByNPAAgeingDaysFunction(payload, count, false)
        } else if (type == "loanRecovered") {
            getLoanRecoveredDetailsFunction(payload, count)
        }
    }


    useEffect(() => {
        getNbfcList()
        GetProduct()
        getRunningLoansCountsFunction(payload)
        getRunningLoansDetailsFunction(payload, pageValues.count)
        getStatsByNPAAgeingDaysFunction(payload, pageValues.count, true)
    }, [])

    const getRunningLoansCountsFunction = (dateFilter) => {
        const newDate = {
            sDate: moment(dateFilter.sDate).format("DD-MM-YYYY"), eDate: moment(dateFilter.eDate).format("DD-MM-YYYY"), nbfcId: dateFilter?.nbfcId,
            productId: dateFilter?.product
        }
        setLoader(true)
        getRunningLoansCountsAPi(newDate, (callback) => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTabData(callback?.data)
                setPageValues((prev) => ({
                    ...prev,
                    total: callback?.data?.totalRunningLoan ?? 0
                }))
            } else {
                setTabData({})
            }
        })
    }


    const getRunningLoansDetailsFunction = (dateFilter, currentPage) => {
        const newDate = {
            sDate: moment(dateFilter.sDate).format("DD-MM-YYYY"), eDate: moment(dateFilter.eDate).format("DD-MM-YYYY"), nbfcId: dateFilter?.nbfcId,
            productId: dateFilter?.product
        }
        setLoader(true)
        getRunningLoansDetailsAPi(newDate, currentPage, itemsPerPage, (callback) => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTableData(callback?.data)
            } else {
                setTableData([])
            }
        })
    }

    const getBisbursedLoansDetailsFunction = (dateFilter, currentPage) => {
        const newDate = {
            sDate: moment(dateFilter.sDate).format("DD-MM-YYYY"), eDate: moment(dateFilter.eDate).format("DD-MM-YYYY"), nbfcId: dateFilter?.nbfcId,
            productId: dateFilter?.product
        }
        setLoader(true)
        getBisbursedLoansDetailsAPi(newDate, currentPage, itemsPerPage, (callback) => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTableData(callback?.data)
            } else {
                setTableData([])
            }
        })
    }

    const getStatsByNPAAgeingDaysFunction = (dateFilter, currentPage, valueType) => {
        const newDate = {
            sDate: moment(dateFilter.sDate).format("DD-MM-YYYY"), eDate: moment(dateFilter.eDate).format("DD-MM-YYYY"), nbfcId: dateFilter?.nbfcId,
            productId: dateFilter?.product
        }
        setLoader(true)
        getStatsByNPAAgeingDaysAPi(newDate, currentPage, itemsPerPage, (callback) => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                if (valueType == false) {
                    setTableData(callback?.data)
                } else {
                    setcurrentOutstanding(callback?.data?.total?.currentOutStanding)
                }
            } else {
                if (valueType == false) {
                    setTableData([])
                } else {
                    setcurrentOutstanding(0)
                }
            }
        })
    }

    const getLoanRecoveredDetailsFunction = (dateFilter, currentPage) => {
        const newDate = {
            sDate: moment(dateFilter.sDate).format("DD-MM-YYYY"), eDate: moment(dateFilter.eDate).format("DD-MM-YYYY"), nbfcId: dateFilter?.nbfcId,
            productId: dateFilter?.product
        }
        setLoader(true)
        getLoanRecoveredDetailsAPi(newDate, currentPage, itemsPerPage, (callback) => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTableData(callback?.data)
            } else {
                setTableData([])
            }
        })
    }

    const handleDownload = () => {
        const newDate = {
            sDate: moment(payload?.sDate).format("DD-MM-YYYY"), eDate: moment(payload.eDate).format("DD-MM-YYYY"), nbfcId: payload?.nbfcId,
            productId: payload?.product
        }
        setLoader(true)
        GetPortfolioOverviewReportByDate(newDate, (callback) => {
            setLoader(false)
        })
    }


    const handleDownloadOutstanding = () => {
        const newDate = {
            sDate: moment(payload?.sDate).format("DD-MM-YYYY"), eDate: moment(payload.eDate).format("DD-MM-YYYY"), nbfcId: payload?.nbfcId,
            productId: payload?.product
        }
        setLoader(true)
        GetPortfolioOverviewcurrentOutstandingReportByDate(newDate, (callback) => {
            setLoader(false)
        })
    }

    return (
        <>
            <div className="PortfolioOverviewSection">
                {
                    loader ? <Loader /> : ''
                }
                <div className="container-fluid">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h3 style={{ fontSize: "30px" }}>Portfolio Overview</h3>
                        <div className="" style={{ display: 'inline-block' }}>
                            <div className='count-div'>
                                <div className='row'>
                                    <div className='col-sm-12 col-xs-12'>
                                        <button className="btn-count-new"><div style={{ fontSize: '14px', color: '#1D3557', fontWeight: '700' }}>
                                            CURRENT OUTSTANDING
                                            <br /><br /></div>
                                            <span style={{ color: '#2B78FF', fontSize: '20px', fontWeight: 700 }}>
                                                {"₹ " + (Number(currentOustanding))?.toLocaleString("en-us") || 0}</span>
                                            &nbsp;
                                            <button className='fa fa-download' onClick={() => handleDownloadOutstanding()}></button>
                                            {/* <span style={{ color: '#2B78FF', fontSize: '12px', fontWeight: '700' }}></span> */}
                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">From</label>
                            <input type="date" id="customDateInput" value={payload.sDate} className='form-control' onChange={(e) => handleChange(e, "sDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">To</label>
                            <input type="date" id="customDateInput" value={payload.eDate} min={payload.sDate} className='form-control' onChange={(e) => handleChange(e, "eDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">NBFC</label>
                            <select className='form-control' value={payload.nbfcId} onChange={(e) => handleChange(e, "nbfcId")}>
                                <option value={''}>All</option>
                                {
                                    nbfcData && nbfcData?.length > 0 ?
                                        nbfcData?.map((v, i) => {
                                            return (
                                                <option value={v?.nbfcId}>{v?.name}</option>
                                            )
                                        })
                                        : ''}
                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Product</label>
                            <select className='form-control' value={payload.product} onChange={(e) => handleChange(e, "product")}>
                                <option value={''}>All</option>
                                {
                                    productList && productList?.length > 0 ?
                                        productList?.map((v, i) => {
                                            return (
                                                <option value={v?.productId}>{v?.productName?.replace(/_/g," ")}</option>
                                            )
                                        })
                                        : ''}
                            </select>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <div style={{ display: 'flex' }}>
                                <button className="btn btn-primary" style={{ marginTop: window.innerWidth > 1800 ? "28px" : '23px', padding: '9px 15px', width: '100%', marginRight: '10px' }} onClick={() => handleActionbtn("apply")}>Apply Filter</button>
                                {
                                    showclearbtn ?
                                        <button className="btn" style={{ marginTop: '23px', padding: '9px 15px', background: 'rgb(255, 255, 255)', border: '1px solid rgba(0, 0, 0, 0.25)', borderRadius: '6px', width: '100%', marginRight: '10px' }} onClick={() => handleActionbtn("clear")}>Clear Filter</button>
                                        : ''}
                                {
                                    tabType === "runningLoans" && TableData?.length > 0 ?
                                        <button className="btn btn-primary" style={{ marginTop: window.innerWidth > 1800 ? "28px" : '23px', padding: '9px 15px', width: '100%' }} onClick={() => handleDownload()}><i class="fa fa-download" aria-hidden="true"></i> Download</button>
                                        : ''}

                            </div>
                        </div>


                    </div>

                    <div className="nbfc-dashboard">
                        <div className="row" >
                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
                                <div className="box-grey-individual" style={tabType === "runningLoans" ? activeTabcss : { cursor: 'pointer' }} onClick={() => handleShowTab("runningLoans")}>
                                    <h3>{tabData?.totalRunningLoan ?? 0}</h3>
                                    <p style={tabType === "runningLoans" ? activeTabcss : {}}>Total Running Loan</p>
                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
                                <div className="box-grey-individual" style={tabType === "disbursmentLoans" ? activeTabcss : { cursor: 'pointer' }} onClick={() => handleShowTab("disbursmentLoans")}>
                                    <h3>{tabData?.totalDisbursedLoan ?? 0}</h3>
                                    <p style={tabType === "disbursmentLoans" ? activeTabcss : {}}>Total Disbursment Loan</p>
                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
                                <div className="box-grey-individual" style={tabType === "npaAgingDays" ? activeTabcss : { cursor: 'pointer' }} onClick={() => handleShowTab("npaAgingDays")}>
                                    <h3>{tabData?.npaAgeingDaysCount ?? 0}</h3>
                                    <p style={tabType === "npaAgingDays" ? activeTabcss : {}}>Total NPA Aging</p>
                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
                                <div className="box-grey-individual" style={tabType === "loanRecovered" ? activeTabcss : { cursor: 'pointer' }} onClick={() => handleShowTab("loanRecovered")}>
                                    <h3>{tabData?.totalRecoveredCount ?? 0}</h3>
                                    <p style={tabType === "loanRecovered" ? activeTabcss : {}}>Total Loan Recovered</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ boxShadow: '0px 4px 23.9px 0px #00000040', padding: '15px', marginTop: '30px', borderRadius: '10px', marginBottom: '30px' }}>


                        {TableData ?
                            <div>
                                <div className='overflow-auto'>
                                    <table className='phocket-table'>
                                        <thead>
                                            {
                                                tabType === "runningLoans" || tabType === "disbursmentLoans" ?
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Mobile Number</th>
                                                        <th>Loan Amount</th>
                                                        <th>Apply Date</th>
                                                        <th>Return Date</th>
                                                        <th>status</th>
                                                    </tr>
                                                    : ''}
                                            {
                                                tabType === "npaAgingDays" ?
                                                    <tr>
                                                        <th>OverDue Days</th>
                                                        <th>Number Of EMI</th>
                                                        <th>Overdue Amount</th>
                                                        <th>Principal</th>
                                                        <th>Interest</th>
                                                        <th>Penalty</th>
                                                    </tr>
                                                    : ''}
                                            {
                                                tabType === "loanRecovered" ?
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Approved Amount</th>
                                                        <th>PayBack Amount</th>
                                                        <th>Due Date</th>
                                                        <th>Paid Date</th>
                                                    </tr>
                                                    : ''}



                                        </thead>
                                        <tbody>
                                            {
                                                tabType === "runningLoans" || tabType === "disbursmentLoans" ?
                                                    TableData?.length > 0 && TableData?.map((nbfc, i) => {
                                                        return (
                                                            <>
                                                                <tr key={i}>
                                                                    <td>{nbfc?.userName || "-"}</td>
                                                                    <td>{nbfc?.mobileNumber || "-"}</td>
                                                                    <td>{nbfc?.loanAmount || "-"}</td>
                                                                    <td>{nbfc?.loanApplyDate || "-"}</td>
                                                                    <td>{nbfc?.loanReturnDate || "-"}</td>
                                                                    <td>{nbfc?.statusName || "-"}</td>
                                                                </tr>
                                                            </>
                                                        )
                                                    }) : ''}
                                            {
                                                tabType === "npaAgingDays" ?
                                                    <>
                                                        {
                                                            TableData?.data?.length > 0 && TableData?.data?.map((nbfc, i) => {
                                                                return (
                                                                    <>
                                                                        <tr key={i}>
                                                                            <td>{nbfc?.interval || "-"}</td>
                                                                            <td>{nbfc?.emiCount || "-"}</td>
                                                                            <td>{nbfc?.overdueAmount || "-"}</td>
                                                                            <td>{nbfc?.principal || "-"}</td>
                                                                            <td>{nbfc?.interest || "-"}</td>
                                                                            <td>{nbfc?.penalty || "-"}</td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })}

                                                        <tr style={{ background: '#02534f', color: '#fff', fontWeight: 'bold' }}>
                                                            <td colSpan={5} style={{ textAlign: 'left' }}>Total Overdue</td>

                                                            <td>{TableData?.total?.totalOverdue || "-"}</td>
                                                        </tr>

                                                    </>
                                                    : ''}
                                            {
                                                tabType === "loanRecovered" ?
                                                    <>
                                                        {
                                                            TableData?.resp?.length > 0 && TableData?.resp?.map((nbfc, i) => {
                                                                return (
                                                                    <>
                                                                        <tr key={i}>
                                                                            <td>{nbfc?.name || "-"}</td>
                                                                            <td>{nbfc?.loanApprovedAmount || "-"}</td>
                                                                            <td>{nbfc?.loanPayBackAmount || "-"}</td>
                                                                            <td>{nbfc?.dueDate || "-"}</td>
                                                                            <td>{nbfc?.paidDate || "-"}</td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })}

                                                        <tr style={{ background: '#02534f', color: '#fff', fontWeight: 'bold' }}>
                                                            <td colSpan={4} style={{ textAlign: 'left' }}>Total Recovered Amount</td>

                                                            <td>{TableData?.totalRecoveredAmount || "-"}</td>
                                                        </tr>

                                                    </>
                                                    : ''}
                                        </tbody>
                                    </table>
                                </div>
                                {
                                    tabType !== "npaAgingDays" ?
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => paginationHandler('left', tabType)}><span className="fa fa-chevron-left" /></button></div>
                                                <div className="col-sm-2 col-xs-12  phoc text-center" >Total: {TableData?.length}&nbsp; of &nbsp; {pageValues?.total}</div>
                                                <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" disabled={pageValues?.buttonDisable} className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => paginationHandler('right', tabType)}><span className="fa fa-chevron-right" /></button></div> </div>
                                        </div>
                                        : ''}
                            </div>
                            : ""}

                    </div>
                </div>
            </div>
        </>
    )
}
